import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminController::post
 * @see app/Http/Controllers/AdminController.php:373
 * @route '/admin/staff/reorder'
 */
export const post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: post.url(options),
    method: 'post',
})

post.definition = {
    methods: ["post"],
    url: '/admin/staff/reorder',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AdminController::post
 * @see app/Http/Controllers/AdminController.php:373
 * @route '/admin/staff/reorder'
 */
post.url = (options?: RouteQueryOptions) => {
    return post.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminController::post
 * @see app/Http/Controllers/AdminController.php:373
 * @route '/admin/staff/reorder'
 */
post.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: post.url(options),
    method: 'post',
})
const reorder = {
    post: Object.assign(post, post),
}

export default reorder